module.exports = __webpack_public_path__ + "static/assets/9cfdd378e4cc977fe663ca932e530ec6.svg";